var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInfoCircle16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.333a6.667 6.667 0 1 1 0 13.333A6.667 6.667 0 0 1 8 1.333ZM7.168 7a.5.5 0 0 0 0 1h.056c.061 0 .111.05.111.111v2.444c0 .061-.05.111-.111.111h-.056a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1h-.055a.112.112 0 0 1-.112-.111V7.333A.333.333 0 0 0 8.334 7H7.167Zm.834-2.667A.833.833 0 1 0 8 6a.833.833 0 0 0 0-1.667Z",
  fill: "#BFC6CE"
})));
export default SvgIcInfoCircle16X16;